import { combineReducers } from "redux";
import postsReducer from './posts'
import postReducer from './post'
import plantsReducer from './plants'
import partnersReducer from './partners'
import benefitsReducer from './benefits'
import tagsReducer from './tags'

export default combineReducers({
    posts: postsReducer,
    post: postReducer,
    partners: partnersReducer,
    plants: plantsReducer,
    benefits: benefitsReducer,
    tags: tagsReducer,
})